module.exports = __webpack_public_path__ + "static/nif-86bf7661ee41ab58376fcabea75ade0d.png";